var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidewalkBuildings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "482px",
    height: "137px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(154, 154, 156)",
    d: "M321.000,124.000 L474.764,124.000 L474.764,137.000 L321.000,137.000 L321.000,124.000 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(154, 154, 156)",
    d: "M328.236,134.000 L328.236,120.000 L482.000,120.000 L482.000,134.000 L328.236,134.000 Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(154, 154, 156)",
    d: "M1.680,124.000 L163.000,124.000 L163.000,137.000 L1.680,137.000 L1.680,124.000 Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(154, 154, 156)",
    d: "M-0.000,120.000 L154.598,120.000 L154.598,134.000 L-0.000,134.000 L-0.000,120.000 Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(235, 223, 208)",
    d: "M340.000,120.000 L340.000,-0.000 L475.000,-0.000 L475.000,120.000 L340.000,120.000 ZM10.000,-0.000 L145.000,-0.000 L145.000,120.000 L10.000,120.000 L10.000,-0.000 Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(255, 255, 255)",
    d: "M354.000,88.588 L354.000,30.412 L392.784,30.412 L392.784,88.588 L354.000,88.588 ZM23.000,30.412 L61.784,30.412 L61.784,88.588 L23.000,88.588 L23.000,30.412 Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(255, 255, 255)",
    d: "M423.000,88.588 L423.000,30.412 L461.784,30.412 L461.784,88.588 L423.000,88.588 ZM92.000,30.412 L130.784,30.412 L130.784,88.588 L92.000,88.588 L92.000,30.412 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidewalkBuildings);
export default __webpack_public_path__ + "static/media/sidewalk-buildings.99b46ceaea8aff02f55169b25b9c743d.svg";
export { ForwardRef as ReactComponent };